import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: [1, 'solid', theme.palette.colors.divider],
    padding: theme.spacing(2),
    [theme.breakpoints.up('mobile')]: {
      justifyContent: 'unset',
      padding: theme.spacing(4),
      '& button': {
        visibility: 'hidden',
      },
      '&:hover': {
        backgroundColor: theme.palette.colors.lightGray,
        '& button': {
          visibility: 'visible',
        },
      },
    },
    height: 110,
  },
  paper: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  info: {
    display: 'flex',
    alignItems: 'center',
  },
  badge: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    width: 120,
    marginLeft: theme.spacing(3),
    [theme.breakpoints.up('mobile')]: {
      width: 200,
    },
  },
  name: {
    marginTop: 4,
  },
}));



// WEBPACK FOOTER //
// ./src/components/LoanOfficerRealEstateAgents/components/RealEstateAgentsList/components/RealEstateAgentCard/useStyles.js